import ApiClient from '@package/services/src/ApiClient'
import { EmptyResult } from '@package/services/src/Result'

import { CardPaymentService } from "./services"
import { CheckoutWithCreditCardRequest } from "./types"

export default class CardPaymentApiService implements CardPaymentService {
  public constructor(private apiClient: ApiClient) { }

  public async checkout(
    request: CheckoutWithCreditCardRequest
  ): Promise<EmptyResult> {
    const { creditCardNumber, ...rest } = request

    await this.apiClient.put('/shoppingCart/paymentMethod/creditCard', {
      body: {
        ...rest,
        creditCardNumber: creditCardNumber.replace('_', '').trim(),
        cid: request.cid.trim(),
      },
    })


    return new EmptyResult()
  }
}
